// 8.3.11 Video Moments UI (merged as `vm`).
const vm = {
 "label": "A situation for you",
 "play": "Play",
 "pause": "Pause",
 "replay": "Replay",
 "showTranscript": "Show transcript",
 "hideTranscript": "Hide transcript",
 "showMeaning": "Show meaning",
 "hideMeaning": "Hide meaning",
 "whatWouldYouSay": "What would you say?",
 "placeholder": "Type your reply in {lang}",
 "respond": "Respond",
 "natural": "That works naturally.",
 "better": "A more natural way could be:",
 "savePhrase": "Save phrase",
 "saved": "Saved",
 "usefulPhrases": "Useful phrases",
 "continueFriend": "Continue in Fluent Friend",
 "openInterview": "Practise a full interview",
 "startMission": "Start the mission",
 "videoFailed": "The video couldn't load — you can still read the scene and reply.",
 "respondFailed": "Couldn't send that — try again.",
 "retryVideo": "Retry video",
 "recommendedLevel": "Recommended level",
 "video": "Video scene",
 "titles": {"vm_cafe_es": "Café order", "vm_hotel_fr": "Hotel reception", "vm_meet_de": "Meeting someone new", "vm_interview_ar": "Job interview opening", "vm_directions_sr": "Asking for directions", "vm_disagree_sr": "A small disagreement"},
 "roles": {"waitress": "waitress", "customer": "customer", "receptionist": "receptionist", "guest": "guest", "interviewer": "interviewer", "candidate": "candidate", "tourist": "tourist", "passer-by": "passer-by"}
};
export default vm;
